import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MntPublicQuoteRoutingModule } from './mnt-public-quote-routing.module';
import { PublicQuoteMasterLayoutComponent } from './public-quote-master-layout/public-quote-master-layout.component';
import { PublicQuoteHomeComponent } from './public-quote-home/public-quote-home.component';
import { MntMasterModule } from '../mnt-master/mnt-master.module'
import { AppMaterialModule } from '../app-material/app-material.module';
import { MntUsersModule } from '../mnt-users/mnt-users.module';
import { MntPublicOrderModule } from '../mnt-public-order/mnt-public-order.module';
import { PublicClientAccountComponent } from './public-client-account/public-client-account.component';
import { PublicClientResetPasswordComponent } from './public-client-reset-password/public-client-reset-password.component';
import { BuilderUrlNotFoundComponent } from './builder-url-not-found/builder-url-not-found.component';

@NgModule({
  imports: [
    CommonModule,
    MntPublicQuoteRoutingModule,
    MntMasterModule,
    AppMaterialModule,
    MntUsersModule,
    MntPublicOrderModule,
    FormsModule
  ],
  declarations: [PublicQuoteMasterLayoutComponent, PublicQuoteHomeComponent, PublicClientAccountComponent, PublicClientResetPasswordComponent, BuilderUrlNotFoundComponent],
  entryComponents: [PublicClientAccountComponent]
})
export class MntPublicQuoteModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/mnt-public-quote.module.ts